import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { cn } from "@/lib/utils";

export function StagingBanner({ className }: { className?: string }) {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "w-full bg-amber-600 text-white",
        "px-3 sm:px-4 py-1.5 text-[12px] sm:text-sm",
        "flex items-center justify-between gap-3",
        className
      )}
    >
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden />
        <span className="truncate">
          <span className="font-semibold">STAGING</span>
          <span className="hidden xs:inline"> · Test Data Only</span>
          <span className="xs:hidden"> · Test</span>
        </span>
      </div>
      <button
        type="button"
        onClick={() => setOpen(false)}
        aria-label="Dismiss staging banner"
        className="shrink-0 rounded-md p-1 hover:bg-white/15 focus-ring focus-visible:ring-white"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
